<style lang="less" scoped>
// .menu-tree {
//   margin: 30px 0 0 0;
// }
.menu_con{
  width: 350px;
  min-height: 240px;
  border-right: 1px solid #eeeff3;
  padding-left: 50px;
  margin-top: 10px;
}
.menu_con:last-child{
  width: 350px;
  min-height: 240px;
  border-right: none;
  padding-left: 50px;
  margin-top: 10px;
}
.el-checkbox-group {
    font-size: 0;
    margin: 10px auto;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">{{ pageTitle }}</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <el-form
          :model="detailForm"
          :rules="pageConfig.formRules"
          ref="detailForm"
          label-width="120px"
          class="detail-form"
        >
          <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item label="角色名称" prop="roleName">
                    <el-input v-model="detailForm.roleName" size="small" :disabled='editFlag'></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="角色描述" prop="described">
                    <el-input v-model="detailForm.described" size="small" :disabled='editFlag'></el-input>
                </el-form-item>
            </el-col>
          </el-row>
          <div class="flex">
            <div class="menu_con" v-if="adminMenuList.length>0">
              <el-checkbox-group v-model="checkList"  v-for="firstMenu in adminMenuList" @change="changeMenu(checkList,'adminMenuList','secondMenusList')" :key="firstMenu.id">
                <el-checkbox :label="firstMenu.id">{{firstMenu.title}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="menu_con">
              <el-checkbox-group v-model="secondCheckList"  v-for="secondMenu in secondMenusList" @change="changeMenu(secondCheckList,'secondMenusList','thirdMenusList')" :key="secondMenu.id">
                <el-checkbox :label="secondMenu.id">{{secondMenu.title}}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div class="menu_con">
              <el-checkbox-group v-model="thirdCheckList"  v-for="thirdMenu in thirdMenusList" @change="changeMenu(thirdCheckList,'thirdMenusList','')" :key="thirdMenu.id">
                <el-checkbox :label="thirdMenu.id">{{thirdMenu.title}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>

          <!-- <div class="flex detail-form-parent-div">
            <div class="flex-1">
              <el-form-item label="功能权限"> -->
                <!-- <el-tree :data="menuList" class="menu-tree" show-checkbox @check-change="onCheckChange"></el-tree> -->
                <!-- <Tree
                  v-if="SaaSFlag"
                  :data="sassMenuList"
                  class="menu-tree"
                  show-checkbox
                  @on-check-change="onCheckChange"
                ></Tree>
                <Tree
                  v-else
                  :data="adminMenuList"
                  class="menu-tree"
                  show-checkbox
                  @on-check-change="onCheckChange"
                ></Tree>
              </el-form-item>
            </div>
            <div class="flex-1">
              <el-form-item label="按钮权限">
                <Tree
                  :data="authMenusList"
                  class="menu-tree"
                  show-checkbox
                  @on-check-change="onSassAuthCheckChange"
                ></Tree>
              </el-form-item>
            </div>
          </div> -->
        </el-form>
      </div>
      <div class="flex-r-end">
        <button class="common-empty-button" @click="resetForm">取 消</button>
        <button class="common-bg-button" @click="submitForm('detailForm')">
          提 交
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageTitle: '角色新增', //标题
      // 默认值设置
      detailForm: {},
      pageConfig: pageConfig,
      editFlag: false, //是否编辑模式
      SaaSFlag: false, //是否显示已选中的
      sassMenuList: [], //saas端所有菜单列表
      adminMenuList: [], //超管端所有菜单列表
      secondMenuArr : [],
      thirdMenuArr : [],
      selMenus: [], //选中的菜单
      selAuths: [], //选中的菜单
      roleMenuList: [], //获取角色菜单
      dealerArr: [], //运营商下拉框
      authMenusList: [], // sass端按钮权限
      checkList:[],//一级菜单选中
      secondCheckList:[],//二级菜单选中
      secondMenusList: [], // 二级菜单
      thirdMenusList: [], // 三级菜单
      thirdCheckList: [], // 三级菜单选中
      MenuCheckedList:[]//菜单选中总list
    }
  },
  methods: {
    // 菜单列表
    init() {
      if (this.$store.state.editId) {
        this.editFlag = true
        this.pageTitle = '角色编辑'
        this.getFormInfo()
        // this.getMenuList()
        this.getRoleMenu(this.$store.state.editId)
      } else {
        this.getMenuList()
      }
      // this.getDealer()
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      _.$S.getFormInfo(
        _,
        _.$A.role.list + '/' + _.$store.state.editId,
        function(res) {
          _.detailForm = res.data.data
          _.SaaSFlag = _.detailForm.roleType == '02' ? false : true
          // _.getMenuList()
        }
      )
    },
    // 表单提交
    submitForm(formName) {
      let _ = this
      //_.detailForm.roleType= '02';
      // _.detailForm.roleTypeName = '4.0_admin'
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _.detailForm.menuIds = this.MenuCheckedList
          _.$S.submitForm(
            _,
            _.$A.role.list,
            _.editFlag,
            _.detailForm,
            pageConfig.listRouter
          )
        }
      })
    },
    // 取消
    resetForm(formName) {
      this.$router.push({
        name: pageConfig.listRouter,
      })
    },
    // 菜单选择
    onCheckChange(val) {
      this.selMenus = []
      val.forEach((item) => {
        this.selMenus.push(item.id)
      })
    },
    //运营商下拉框
    getDealer() {
      let _ = this
      _.$H.post(_, _.$A.dealer.allList, {}).then((res) => {
        _.dealerArr = res.data.data
      })
    },
    // 所有的菜单列表
    getMenuList() {
      var _this = this
      var adminflag = -1
      var sassflag = -1
      var pidNamesObj = {}
      let sassBtnsAuthObj = {}
      _this.$H.post(_this, _this.$A.menu.allList, {}).then(function(res) {
        var dbList = res.data.data
        var sortList = dbList.sort(_this.$U.compare('sort'))


        _this.adminMenuList = []
        _this.sassMenuList = []
        sortList.forEach((item, index) => {
          if(item.menuLevel === 1){
            let p = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              // expand: checked,
              children: [],
              menuClass:item.menuClass,
              // checked: checked,
            }
            _this.adminMenuList.push(p)
            console.log(_this.adminMenuList);
          }
          if(item.menuLevel === 2){
            let p = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              // expand: checked,
              menuClass:item.menuClass,
              children: [],
              // checked: checked,
            }
            _this.secondMenuArr.push(p)
          }
          if(item.menuLevel === 3){
            let p = {
              title: item.menuNameZh,
              id: item.id,
              level: item.menuLevel,
              pid: item.pId,
              // expand: checked,
              menuClass:item.menuClass,
              children: [],
              // checked: checked,
            }
            _this.thirdMenuArr.push(p)
            // console.log(thirdMenuArr);
          }
        })
        // for (let v of _this.secondMenuArr) {
        //   if(v.menuClass == 'hasChild'){
        //     v.children = _this.thirdMenuArr.filter(i=>i.pid == v.id)
        //   }
        // }
        // for (let v of _this.adminMenuList) {
        //   if(v.menuClass == 'hasChild'){
        //     v.children = _this.secondMenuArr.filter(i=>i.pid == v.id)
        //   }
        // }
        //  _this.secondMenusList = []
        //  _this.thirdMenusList = []
        // if (_this.checkList.length>0) {
        //   for(let id of _this.checkList){
        //       _this.secondMenusList.push(..._this.adminMenuList.find(v=>v.id == id).children)
        //   }
        //   for(let v of _this.secondMenusList){
        //     if(v.menuClass == 'hasChild'&& _this.secondCheckList.indexOf(v.id)!= '-1'){
        //       _this.thirdMenusList.push(...v.children);
        //     }
        //   }
        // }
          console.log(_this.secondMenuArr);
        for (let v of _this.secondMenuArr) {
          console.log(v);
          console.log(_this.thirdMenuArr);
          if(v.menuClass == 'hasChild'){
            v.children = _this.thirdMenuArr.filter(i=>i.pid == v.id)
          }
        }
        for (let v of _this.adminMenuList) {
          if(v.menuClass == 'hasChild'){
            v.children = _this.secondMenuArr.filter(i=>i.pid == v.id)
          }
        }
         _this.secondMenusList = []
         _this.thirdMenusList = []
        if (_this.checkList.length>0) {
          for(let id of _this.checkList){
            _this.secondMenusList.push(..._this.adminMenuList.find(v=>v.id == id).children)
              
          }
          console.log(_this.thirdMenusList);
          for(let v of _this.secondMenusList){
            if(v.menuClass == 'hasChild'&& _this.secondCheckList.indexOf(v.id)!= '-1'){
              _this.thirdMenusList.push(...v.children);
            }
            // if(_this.secondCheckList.indexOf(v.id)!= '-1'){
            //   _this.thirdMenusList.push(...v.children);
            // }
           
          }
           console.log(_this.thirdMenusList);
        }
      })
      console.log(_this.adminMenuList);
      console.log(_this.secondMenusList);
      console.log(this.thirdMenusList);
    },
    // 获取角色菜单
    getRoleMenu(roleId) {
      var _this = this
      _this.checkList = []
      _this.secondCheckList = []
      _this.thirdCheckList = []
      var url = _this.$A.role.listmenu
      _this.$H
        .post(_this, url, {
          roleId: roleId,
        })
        .then((response) => {
          response.data.data.forEach((item, index) => {
            if(item.menuLevel == 1){
              this.checkList.push(item.id)
            }else if(item.menuLevel == 2){
              this.secondCheckList.push(item.id);
            }else if(item.menuLevel == 3){
              this.thirdCheckList.push(item.id)
            }
          })
          // 初始化菜单
          _this.getMenuList()
        })
    },
    changeMenu(ckeckList,list,listName){
      this[`${listName}`] = []
      if(ckeckList.length>0){
        for(let id of ckeckList){
          this[`${listName}`].push(...this[`${list}`].find(item=>item.id == id).children);
          if(listName == 'secondMenusList'){
            this.thirdCheckList = []
            this.thirdMenusList = []
            this.secondCheckList = this[`${listName}`].map(i=>i.id)
            this[`${listName}`].forEach(i=>{
              if(i.menuClass == 'hasChild'){
                for(let v of i.children){
                  this.thirdMenusList.push(v);
                  this.thirdCheckList.push(v.id)
                }
              }
            })
            this.thirdMenusList = Array.from(new Set(this.thirdMenusList))
            this.thirdCheckList = Array.from(new Set(this.thirdCheckList))
          }
          if(listName == 'thirdMenusList'){
            this.thirdCheckList = this[`${listName}`].map(i=>i.id)
          }
        }
        this.MenuCheckedList = this.checkList.concat(this.secondCheckList).concat(this.thirdCheckList)
      }
      // console.log(listName,this[`${listName}`]);
      console.log('MenuCheckedList',this.MenuCheckedList);
    },
    //选择运营商
    handleDealChange(val) {
      this.detailForm.dealerName = val
    },
    // 按钮选择
    onSassAuthCheckChange(val) {
      this.selAuths = []
      val.forEach((item) => {
        this.selAuths.push(item.id)
      })
    },
  },
  mounted() {
    // 面包屑配置
    this.$store.commit('setBreadCrumbList', pageConfig.detailBreadCrumb)
    this.init()
  },
}
</script>
